import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const C = {
  navy: '#0D1B2A', teal: '#00B4D8', success: '#10B981', warning: '#F59E0B',
  error: '#EF4444', grey: '#6B7280', border: '#E5E7EB', bg: '#F8FAFC', white: '#FFFFFF',
};

const TYPE_LABEL = { course: 'Course', mock_test: 'Mock Test', extra_session: 'Extra Session' };
const TYPE_ICON  = { course: '🎓', mock_test: '🧪', extra_session: '➕' };
const STATUS = {
  pending:   { label: 'Awaiting payment', color: C.warning, bg: '#FEF3C7' },
  submitted: { label: 'Under review',     color: '#3B82F6', bg: '#EFF6FF' },
  confirmed: { label: 'Paid',             color: C.success, bg: '#D1FAE5' },
  rejected:  { label: 'Rejected',         color: C.error,   bg: '#FEE2E2' },
  cancelled: { label: 'Cancelled',        color: C.grey,    bg: '#F1F5F9' },
};

export default function StudentPayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/student/payments')
      .then(r => setRows(Array.isArray(r.data) ? r.data : []))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  const fmtDate = (s) => {
    if (!s) return '—';
    try { return new Date(s).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch { return s; }
  };
  const money = (r) => `${r.currency === 'GBP' ? '£' : '$'}${Number(r.amount_usd || 0).toFixed(2)}`;

  const totalPaid = rows.filter(r => r.status === 'confirmed').reduce((a, r) => a + Number(r.amount_usd || 0), 0);

  return (
    <div style={{ minHeight: '100vh', background: C.bg, padding: '32px 20px' }}>
      <div style={{ maxWidth: 860, margin: '0 auto' }}>
        <h1 style={{ color: C.navy, fontSize: 26, fontWeight: 800, margin: '0 0 4px' }}>My Payments</h1>
        <p style={{ color: C.grey, margin: '0 0 24px' }}>A permanent record of every payment on your account. This history cannot be edited or deleted.</p>

        {!loading && rows.length > 0 && (
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 14, padding: '16px 20px', marginBottom: 20, display: 'flex', gap: 32, flexWrap: 'wrap' }}>
            <div><div style={{ color: C.grey, fontSize: 12, fontWeight: 600 }}>TOTAL PAID</div><div style={{ color: C.success, fontSize: 22, fontWeight: 800 }}>${totalPaid.toFixed(2)}</div></div>
            <div><div style={{ color: C.grey, fontSize: 12, fontWeight: 600 }}>RECORDS</div><div style={{ color: C.navy, fontSize: 22, fontWeight: 800 }}>{rows.length}</div></div>
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', color: C.grey, padding: 40 }}>Loading…</div>
        ) : rows.length === 0 ? (
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 14, padding: 48, textAlign: 'center', color: C.grey }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🧾</div>
            No payments yet. Course, mock test and extra-session payments will appear here automatically.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {rows.map((r) => {
              const st = STATUS[r.status] || STATUS.pending;
              return (
                <div key={r.id} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 14, padding: 18, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                  <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <div style={{ fontSize: 26 }}>{TYPE_ICON[r.type] || '💳'}</div>
                    <div>
                      <div style={{ fontWeight: 700, color: C.navy, fontSize: 15 }}>{r.description || TYPE_LABEL[r.type] || 'Payment'}</div>
                      <div style={{ color: C.grey, fontSize: 13, marginTop: 3 }}>
                        {TYPE_LABEL[r.type] || r.type} · {fmtDate(r.created_at)}
                        {r.status === 'confirmed' && r.confirmed_at && <> · paid {fmtDate(r.confirmed_at)}</>}
                      </div>
                      {r.status === 'rejected' && r.rejected_reason && (
                        <div style={{ color: C.error, fontSize: 12, marginTop: 4 }}>Reason: {r.rejected_reason}</div>
                      )}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    {r.proof_url && (
                      <a href={r.proof_url} target="_blank" rel="noreferrer" style={{ color: C.teal, fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>View proof</a>
                    )}
                    <span style={{ fontWeight: 800, color: C.navy, fontSize: 16 }}>{money(r)}</span>
                    <span style={{ fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 20, background: st.bg, color: st.color }}>{st.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
